import { mockDataUtil } from './mockDataUtil';
import {warehouseList} from "../mock/mockWarehouseData";
import {API_ENDPOINTS} from "../utils/apiEndpoints";
import httpClient from './httpClient';
import {WHOLE_USE_MOCK} from "./api";

class WarehouseService {

   async getMock() {
    return true;
  }

  /**
   * 获取仓库列表
   */
  async getWarehouses(searchParams) {
    if (await this.getMock() && WHOLE_USE_MOCK) {
      // 处理分页参数，与角色服务保持一致
      const pageSize = searchParams.pageSize || 10;
      const currentPage = searchParams.currentPage || 1;
      const startIndex = (currentPage - 1) * pageSize;
      const endIndex = startIndex + pageSize;
      
      // 过滤数据
      let filteredWarehouses = [...warehouseList];
      
      // 根据查询条件过滤
      if (searchParams.code) {
        filteredWarehouses = filteredWarehouses.filter(warehouse =>
            warehouse.code.toLowerCase().includes(searchParams.code.toLowerCase())
        );
      }
      
      if (searchParams.name) {
        filteredWarehouses = filteredWarehouses.filter(warehouse =>
            warehouse.name.toLowerCase().includes(searchParams.name.toLowerCase())
        );
      }
      
      if (searchParams.format) {
        filteredWarehouses = filteredWarehouses.filter(warehouse =>
            warehouse.format === searchParams.format
        );
      }
      
      if (searchParams.clusterSection) {
        filteredWarehouses = filteredWarehouses.filter(warehouse =>
            warehouse.clusterSection === searchParams.clusterSection
        );
      }
      
      const paginatedWarehouses = filteredWarehouses.slice(startIndex, endIndex);

      return mockDataUtil.mockPageRes(paginatedWarehouses, {
            currentPage: currentPage,
            totalCount: filteredWarehouses.length,
            pageSize: pageSize
      });
    } else {
      let res = await httpClient.post(API_ENDPOINTS.STORE.PAGE, searchParams);
      return res.data;
    }
  }

  /**
   * 仓库下拉
   */
  async listWarehouse(searchReq) {
    if (await this.getMock() && WHOLE_USE_MOCK) {
      const result = warehouseList.filter(w => w.name.includes(searchReq.searchStr) || w.code.includes(searchReq.searchStr));
      return mockDataUtil.mockRes(result);
    } else {
      let res = await httpClient.post(API_ENDPOINTS.STORE.LIST, searchReq);
      return res.data;
    }
  }

  async multiQueryWarehouse(query) {
    if (await this.getMock() && WHOLE_USE_MOCK) {
      const result = warehouseList;
      return mockDataUtil.mockRes(result);
    } else {
      let res = await httpClient.post(API_ENDPOINTS.STORE.LIST, query);
      return res.data;
    }
  }
}

export const warehouseService = new WarehouseService();